export default __webpack_public_path__ + "static/media/Coffee.e30cbb95.png";